module.exports = __webpack_public_path__ + "static/media/arrow_green.0485dcd3.svg";